const { atom } = require("recoil");

export const yearState = atom({
  key: "yearState",
  default: "2021"
});

export const dashboardReportsState = atom({
  key: "dashboardReportsState",
  default: []
});

export const dashboardTargetListingState = atom({
  key: "dashboardTargetListingState",
  default: []
});

export const badgeReceiverState = atom({
  key: "badgeReceiverState",
  default: []
});

export const successStoryListingState = atom({
  key: "successStoryListingState",
  default: []
});

export const companyTargetDisplayState = atom({
  key: "companyTargetDisplayState",
  default: []
});

export const isAssignedToTargetsState = atom({
  key: "isAssignedToTargetsState",
  default: false
});